import { connect } from 'react-redux';
import clsx from 'clsx';
import { AlertBannerComponent } from 'src/universal/components/AlertBanner';
import InFlowAlertStyles from './__styles__/index.scss?modules';
import { getInFlowAlertBannerData } from './redux';

const mapStateToProps = (state, ownProps) => ({
  classname: clsx('inFlowAlertBanner', ownProps.classname),
  styles: InFlowAlertStyles,
  maxWidth: null,
  closeIcon: null,
  ...getInFlowAlertBannerData(state)
});

export default connect(mapStateToProps)(AlertBannerComponent);
